module.exports = {"70x70": __webpack_public_path__ + "images/comet-moon-3-70x70.png"};